import { render } from "./App2.vue?vue&type=template&id=046322d0"
import script from "./App2.vue?vue&type=script&lang=js"
export * from "./App2.vue?vue&type=script&lang=js"

import "./App2.vue?vue&type=style&index=0&id=046322d0&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__